.order-return-overview {
    &__filter-container {
        @include clearfix();

        .ux-tag {
            background-color: $color-blue-highlight-1;
        }

        .datepicker-range {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: flex-start;
        }

        .datepicker-range__divider {
            flex: 0 0 20px;
        }

        .datepicker {
            flex: 1 1 auto;
        }
    }

    &__filter-dropdown {
        min-width: 250px;
        max-width: 300px;
        position: relative;
        display: inline-block;
        margin-right: 18px;
        margin-bottom: 20px;
    }

    &__result-set.result-set {
        margin-top: 0;
        position: relative;
        text-align: center;
    }

    &__table-container {
        .ux-text-status {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: flex-start;
        }

        .ux-text-status::before {
            content: "";
            display: inline-block;
            background-color: currentColor;
            width: 0.8em;
            height: 0.8em;
            border-radius: 100%;
            margin-right: 0.8em;
        }
    }

    .ux-collapsible-button__container {
        padding: $dim-15;
        text-align: center;
    }
}
